export const getHelpList = (store) => store.help.data;

export const getPaginationInfo = (store) => {
  const { data, ...rest } = store.help;
  return rest;
};
